import React from 'react';
import AssignmentTable from 'components/Tables/AssignmentTable';

const Index = () => {
  return <AssignmentTable />;
};

export default Index;
